<script setup lang="ts">
  // Context
  import { useDiscoveryRootContext } from './DiscoveryRoot.vue'

  // Composables
  import { useDiscovery } from '@/composables/useDiscovery'

  // Stores
  import { useSkillzStore } from '@/stores/skillz'

  // Utilities
  import { useRouter } from 'vue-router'

  defineOptions({ name: 'DiscoverySkip' })

  const root = useDiscoveryRootContext('v0:discovery')
  const discovery = useDiscovery()
  const skillz = useSkillzStore()
  const router = useRouter()

  function skip () {
    const tour = discovery.tours.selectedItem.value
    const returnRoute = tour?.id ? `/skillz/${tour.id}` : '/skillz'

    if (root.isLast.value) {
      skillz.complete()
      router.push(tour?.completeRoute ?? returnRoute)
    } else {
      skillz.stop()
      router.push(returnRoute)
    }
  }
</script>

<template>
  <button
    :aria-label="root.isLast.value ? 'Complete tour' : 'Skip tour'"
    type="button"
    @click="skip"
  >
    <slot />
  </button>
</template>
